// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-question__error-message {\n  color: red;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
